import {map} from 'rxjs/operators';
import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ParameterService} from '../services/parameter.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DatePipe, Location} from '@angular/common';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Alert, AlertType} from '../../shared/alert.model';
import {MessageService} from '../../shared/message.service';
import {getAlertMessage} from '../../shared/api-loaders';
import {Observable, Subscription} from 'rxjs';
import {MessageType} from '../../shared/messageType';
import {ClaimsService} from '../../shared/claims.service';
import {CustomValidators} from '../validators/blank-validator';
import {ParameterValueValidator} from '../validators/parameter-value-validator';
import {Parameter} from '../models/parameter';
import {Select2Option} from '../../shared/select2-option';
import {ParametersDeleteConfirmationDialogComponent} from '../parameters-delete-confirmation-dialog/parameters-delete-confirmation-dialog.component';
import {StackService} from '../services/stack.service';
import {Stack} from '../models/Stack';
import {SecurityService} from '../../shared/security.service';
import {ConfigurationService} from '../services/configuration.service';
import {CustomerService} from '../services/customer.service';
import {ModalService} from '../../shared/modal.service';

@Component({
    selector: 're-stack-detail',
    templateUrl: './stack-detail.component.html',
    styleUrls: ['./stack-detail.component.scss'],
    standalone: false
})
export class StackDetailComponent implements OnInit {

  id: number;


  loading: boolean;

  stackId: number = 4;

  successAlert: Alert;
  alert: Alert;
  showMessage = false;
  hasGlobalError = false;
  editProfile: boolean;
  modalReference: any;
  username: string;
  stackName: string;
  stack: Stack;
  snfApiKey = 'snf.api.url.root';
  mcslApiKey = 'sl.api.url.root';

  newConfig: boolean;
  editParameters: boolean;
  configCollapse: boolean;
  public parameterId: number;
  public corpOid: any=null;
  public snfAppUrl: any=null;
  enabledDisableData: Select2Option[];
  gsEnabledData: Select2Option[];
  gsEnabled: boolean;
  parameter = new Parameter();
  newParameter: boolean;
  deleteParameterIds: number[] = [];
  isError: boolean;
  snfCorpOidKey = 'snf.corpOid';
  snfAppUrlKey = 'snf.app.url.root';
  batchUpErrorMap : Map<number,boolean> = new Map();
  hasBatchValidationError: boolean;
  somethingIsChecked: boolean;
  isReadOnlyUser: boolean;
  errorMessage:string;
  addError=false;
  caHotReloading = false;


  parameterDetailForm: UntypedFormGroup = this.fb.group({
    id: [''],
    configurationId: [''],
    key: ['', CustomValidators.blankValidator],
    value: ['',null, _ => ParameterValueValidator.validate2(this.parameterDetailForm?.controls['value'],this.parameterDetailForm?.controls['key'],this.corpOid,this.snfAppUrl,this.configurationService,this.customerService, null,null,false)],
    environmentKey: ['']
  });

  parameterKeysForm: UntypedFormGroup = this.fb.group({
    corpOid: [this.corpOid],
    snfAppUrl: [this.snfAppUrl]
  });

/*  parametersEditForm: FormGroup = this.fb.group({
    id: [''],
    configurationId: [''],
    key: ['', CustomValidators.blankValidator],
    value: ['', Validators.compose([CustomValidators.blankValidator, _ => ParameterValueValidator.validate(this.parametersEditForm, this.parametersEditKeysForm,this.configurationService)])],
    environmentKey: ['']
  });*/

  parametersEditKeysForm: UntypedFormGroup = this.fb.group({
    corpOid: [this.corpOid],
    snfAppUrl: [this.snfAppUrl]
  });

  messageSubscription: Subscription;
  confirmationWindowRef: NgbModalRef;


  constructor(
    private route: ActivatedRoute,
    private stackService: StackService,
    private location: Location,
    private cdr: ChangeDetectorRef,
    private fb: UntypedFormBuilder,
    private modalService: ModalService,
    private parameterService: ParameterService,
    private messageService: MessageService,
    private claimsService: ClaimsService,
    private router: Router,
    private datepipe: DatePipe,
    private securityService: SecurityService,
    private configurationService: ConfigurationService,
    private customerService: CustomerService

  ) {
    this.messageSubscription = this.messageService.get().subscribe(message => {
      if (message.type == MessageType.ParameterCreated) {
        this.alert = {type: AlertType.SUCCESS, message: `Parameter ${message.data} has been created successfully`};
      }
      this.clearAlerts();
    });



      this.editProfileClicked();
  }

  ngOnDestroy(): void {
    this.messageSubscription.unsubscribe();
  }

  async ngOnInit() {
    this.parameterDetailForm.controls['key'].valueChanges.subscribe(x => {
      this.parameterDetailForm.controls['value'].updateValueAndValidity();
    });
    $(function () {
      $('[data-toggle="tooltip"]')["tooltip"]();
    });

    this.isReadOnlyUser = await this.securityService.isThisReadOnlyUser();

    await this.loadOptions();
    this.getStack();
    this.username = this.claimsService.getPreferredName();
    this.parameterService.getStackParameters().subscribe(data => {
      this.groupedParameters = this.groupByProductName(data);
      this.callHealthchecks();
    });

  }

  public groupedParameters: any;
  public groupedParametersOld: any;

  public getProductKeys(): Array<string> {
    if (!this.groupedParameters)
      return [];

    return Object.keys(this.groupedParameters).sort((a, b) => a.localeCompare(b));
  }

  public isProductCollapsed: { [key: string]: boolean } = {};

  expandAll() {
    var keys = this.getProductKeys();
    keys.forEach(x => this.isProductCollapsed[x] = false);
  }

  collapseAll() {
    var keys = this.getProductKeys();
    keys.forEach(x => this.isProductCollapsed[x] = true);
  }




  async showBulkParameterDeleteConfirmationWindow(deleteCount) {
    this.loading = true;
    var modal = this.modalService.create<ParametersDeleteConfirmationDialogComponent>(ParametersDeleteConfirmationDialogComponent);

    let deleteCount2: { deleteCount: number }={
      deleteCount:deleteCount
    };
    modal.component.deleteCount=deleteCount2;
    var result = await modal.modalRef.result;

    if (result) {
      this.parameterService.deleteBatchParameter(this.deleteParameterIds.toString()).subscribe(
        res => {
        //  this.resetParameterFlags();
          this.refreshParams();
          this.editParameters = false;

        },
        error => {
          this.alert = getAlertMessage(error);
        }
      );
    }

  }

  private productNames = {};
  public addingText: string = null;

  async refreshForm(stack) {
    this.isError=false;
    this.parameterService.getStackParameters().subscribe(data => {
      this.groupedParameters = this.groupByProductName(data);
      this.callHealthchecks();
    });
    this.stackId = stack.id;
    this.stackName = stack.stackName;

    var products = await this.parameterService.getProductNames().toPromise();
    products.forEach(x => {
      this.productNames[x.key] = x.name;
    });

  }

  async refreshParams() {
    this.isError=false;
    this.parameterService.getStackParameters().subscribe(data => {
      this.groupedParameters = this.groupByProductName(data);
      this.callHealthchecks();
    });

    var products = await this.parameterService.getProductNames().toPromise();
    products.forEach(x => {
      this.productNames[x.key] = x.name;
    });

  }

  callHealthchecks() {
    Object.keys(this.groupedParameters).forEach(groupName => {
      this.groupedParameters[groupName].forEach(async parameter => {
        // Call Health Check to Check SNF/SL Api
        if ((parameter['key'] === this.snfApiKey || parameter['key'] === this.mcslApiKey) && parameter.hasOwnProperty('value') && parameter['value'] !== '') {
          parameter['status'] = 'LOADING';
          await this.parameterService.getApiHealthchecks(parameter['key'], parameter['value']).subscribe(result => {
            parameter['status'] = result['status'];
            if (parameter['status'] === 'DOWN') {
              parameter['errorMessage'] = 'API service is unavailable.';
            }
          });
        }
        if((parameter['key'] === this.snfAppUrlKey)&& parameter.hasOwnProperty('value') && parameter['value'] !== ''){
          this.snfAppUrl = parameter.value;
        }
        if((parameter['key'] === this.snfCorpOidKey)&& parameter.hasOwnProperty('value') && parameter['value'] !== ''){
          this.corpOid = parameter.value;
        }
      });
    });
  }

  getNgStyleColorBasedOnStatus(status) {
    if (status === 'LOADING') {
      return '#141888';
    } else if (status === 'UP') {
      return '#26882B';
    } else if (status === 'DOWN') {
      return '#ff0000';
    } else {
      return '#1e2aff';
    }
  }

  groupByProductName(parameters: any[]): any {
    const groups = {};

    for (const x of parameters) {
      const productName = this.getProductDisplayName(x.key.split('.')[0]);
      groups[productName] = groups[productName] || [];
      groups[productName].push({ ...x, status: '', errorMessage: '' });
    }

    return groups;
  }


  getProductDisplayName(productName: any): any {
    if (this.productNames[productName])
      return this.productNames[productName];

    return productName;
  }

  isCareAssistGroup(productName: string): boolean {
    const normalized = (productName || '').replace(/\s+/g, '').toLowerCase();
    return normalized === 'careassist' || normalized === 'ca';
  }

  goBack(): void {
    this.location.back();
  }

  clearAlerts() {

    this.hasGlobalError = false;
    setTimeout(() => {
      this.alert = null;
      this.showMessage = false;
    }, 5000);
  }

  editProfileClicked() {
    this.editProfile = true;
    this.configCollapse = false;
  }

  editParametersClicked() {
    this.editParameters = true;
    this.parameterService.getStackParameters().subscribe(data => {
      this.groupedParametersOld = this.groupByProductName(data.filter(x => x.stackId === this.stackId));
    });
  }

  resetFlags() {
    this.editProfile = false;
    this.getStack();
  }

  resetParameterFlags() {
    this.editParameters = false;
  }



   getStack(): void {
      if (!this.stackId)
        return;

      this.loading = true;
      const id = +this.route.snapshot.paramMap.get('id');
      this.stackService.getCurrentStack().subscribe(stack => {
        this.refreshForm(stack);
        this.loading = false;
      });
      //this.parameterService.getParameter(this.parameterId).subscribe(parameter => this.refreshForm(parameter));
    }



  // TODO: Make use of the functions available in config-list component with component to component interaction to avoid code duplication



//not used
/*  async showConfirmationWindow() {
    this.confirmationWindowRef = this.modalService.open(AddParametersConfirmationWindowComponent);

    const comp = <AddParametersConfirmationWindowComponent>this.confirmationWindowRef.componentInstance;
    this.parameterService.getProductNames().subscribe((x) => {

      comp.productNames = x.filter(x => x.isDefault).map(x => x.name).join(",");
    });

    const result: any = await this.confirmationWindowRef.result;
    return result;
  }*/




  addParameter(): void {
    const parameter = new Parameter(this.parameterDetailForm.value);

    Object.keys(this.groupedParameters).forEach(groupName => {
      for (var i = 0; i < this.groupedParameters[groupName].length; i++) {
        for(let p of this.groupedParameters[groupName].filter(x => x.key.trim() ==parameter.key.trim())){
            this.errorMessage="Key already exists and cannot be re-added.";
            this.addError=true;
            this.loading=false;
            break;
        }
      }
    });

    if(!this.addError){
      this.newParameter = true;
      let obs: Observable<Parameter>;

      parameter.stackId = this.stackId;
      parameter.createdBy = this.username;
      delete parameter.environmentKey;
      delete parameter.corpOid;
      delete parameter.id;
      obs = this.parameterService.addParameter(parameter);
      this.resetFlags();

      obs.subscribe(
        data => {
          // If customer was updated successfully, id must have some value.
          if (this.parameterId) {
            this.resetFlags();
            this.successAlert = {
              message: `Parameter ${parameter.key} has been updated successfully`,
              type: AlertType.SUCCESS
            };

            this.clearAlerts();
          } else {
            status => {
              console.log("in else bc new param");
              this.messageService.send({type: MessageType.ParameterCreated, data: parameter.key});
            };
          }
        },
        err => {
          console.log("in error");
          this.alert = getAlertMessage(err);
        }
      );
      this.parameterDetailForm.patchValue({
        key: "",
        value: ""
      });
      this.parameterDetailForm.markAsUntouched();
    }

  }

  updateParameter(): void {
    this.newParameter = false;
    let parameterObject = [];

    Object.keys(this.groupedParameters).forEach(groupName => {
      var newParameterRow;
      var oldParameterRow;
      for (var i = 0; i < this.groupedParameters[groupName].length; i++) {
        newParameterRow = this.groupedParameters[groupName][i];
        oldParameterRow = this.groupedParametersOld[groupName].filter(x => x.id ==newParameterRow.id)[0];
          if (JSON.stringify(newParameterRow.key) === JSON.stringify(oldParameterRow.key) &&
            JSON.stringify(newParameterRow.value) === JSON.stringify(oldParameterRow.value)) {
        }
        else {
          let obj = {
            stackId: this.stackId,
            id: this.groupedParameters[groupName][i].id,
            key: this.groupedParameters[groupName][i].key,
            value: this.groupedParameters[groupName][i].value,
            modifiedBy: this.username
          };
          parameterObject.push(obj);
        }
      }
    });

    if (parameterObject.length > 0) {
      let obs: Observable<Parameter>;
      obs = this.parameterService.updateBatchParameter(this.stackId, parameterObject);  // for now. TODO change all the chanin calls not to use configID or stackID to update parameters as it already has it.
      obs.subscribe(
        configuration => {
          // If customer was updated successfully, id must have some value.
          if (this.stackId) {   //TODO fix this check
            this.resetParameterFlags();
            this.resetFlags();
            this.successAlert = {
              message: `Stack ${this.stackId} has been updated successfully`,
              type: AlertType.SUCCESS
            };
            this.clearAlerts();
          } else {
            status => {
              this.messageService.send({type: MessageType.ParameterCreated, data: this.stackId});
            };
          }
        },
        err => {
          this.alert = getAlertMessage(err);
        }
      );
    }
    this.editParameters = false;
  }

  public checkDefaultText() {
    this.errorMessage="";
    this.addError=false;
    if (this.parameterDetailForm.get('key').value.includes('bp.globalsearch.displayformat')) {
      this.gsEnabled = true;
      return 'First Name \"Preferred Name\" Last Name';
    } else {
      this.gsEnabled = false;
      return 'False';
    }
  }

  public checkDefaultTextMultiEdit(key) {
    if (key.includes('bp.globalsearch.displayformat')) {
      return 'First Name \"Preferred Name\" Last Name';
    } else {
      return 'False';
    }
  }

  public checkSelect() {

    if (this.parameterDetailForm.get('key').value.includes('bp.globalsearch.displayformat')) {
      this.gsEnabled = true;
      return true;
    } else if (this.parameterDetailForm.get('key').value.includes('enabled') || this.parameterDetailForm.get('key').value.includes('isdefault')) {
      return true;
    } else {
      this.gsEnabled = false;
      return false;
    }
  }

  public checkSelectMultiEdit(key) {
    this.gsEnabled = false;
    if (key.includes('bp.globalsearch.displayformat')) {
      this.gsEnabled = true;
      return true;
    } else if (key.includes('enabled') || key.includes('isdefault')) {
      return true;
    } else {
      this.gsEnabled = false;
      return false;
    }
  }

  private async loadOptions() {
    await this.parameterService.getEnableDisableOptions().pipe(map(data => {
      this.enabledDisableData = data
    })).toPromise();
    await this.parameterService.getGSDisplayOptions().pipe(map(data => {
      this.gsEnabledData = data
    })).toPromise();
  }

  async refreshParameterListForm() {
    this.parameterService.getStackParameters().subscribe(data => {
      this.groupedParameters = this.groupByProductName(data.filter(x => x.stackId === this.stackId));
      this.callHealthchecks();
    });
    var products = await this.parameterService.getProductNames().toPromise();
    products.forEach(x => {
      this.productNames[x.key] = x.name;
    });
  }

  checkAllCheckBox(ev,productGroupSelected) {
    this.somethingIsChecked=false;
    //this handles each individual grouping
    this.groupedParameters[productGroupSelected].forEach(x =>
      x.checked = ev.target.checked
    );
    //this handles enabling/disabling delete button based on if anything is selected in ANY grouping
    Object.keys(this.groupedParameters).forEach(groupName => {
      this.groupedParameters[groupName].forEach(u => {
        if (u.checked) {
          this.somethingIsChecked = true;
        }
      });
    });
  }

  onCheck(){
    this.somethingIsChecked=false;
    Object.keys(this.groupedParameters).forEach(groupName => {
      this.groupedParameters[groupName].forEach(u => {
        if (u.checked) {
          this.somethingIsChecked=true;
        }
        //this unselects the select all for that product grouping if one of the keys under that grouping is not checked
        (document.getElementById('cb_slselectall_'+ groupName) as HTMLInputElement).checked = false;

      });
    });
  }

  deleteBatchParameters() {
    this.deleteParameterIds = [];
    Object.keys(this.groupedParameters).forEach(groupName => {
      this.groupedParameters[groupName].forEach(x => {
        if (x.checked) {
          this.deleteParameterIds.push(x.id);
        }
      });
    });
    if (this.deleteParameterIds.length > 0) {
      this.showBulkParameterDeleteConfirmationWindow(this.deleteParameterIds.length);
    }
    this.editParameters = false;
    this.somethingIsChecked = false;
  }

  onChange(value: string, event: KeyboardEvent, key: string) {
    //this ensures that the two properties are updated BEFORE the validator is called as we need them for valdiation
    if(key.toLowerCase().includes("snf.corpoid")){
      var corpOid = Number((value||"")+event.key);
      this.corpOid = corpOid;
    }

    if(key.includes("snf.app.url.root")){
      var snfAppUrl = (value||"")+event.key;
      this.snfAppUrl = snfAppUrl;
    }

  }

/*  checkBatchValidationError() : boolean{
    for (let value of this.batchUpErrorMap.values()) {
      if (value) return true;
    }
    return false;
  }*/

  cancelParameters() {
    this.editParameters = false;
    $('#cb_slselectall').prop('checked', false);
    this.uncheckAllCheckBox();
    this.loading = false;
  }

  uncheckAllCheckBox() {
    Object.keys(this.groupedParameters).forEach(groupName => {
      this.groupedParameters[groupName].forEach(x =>
        x.checked = false);
      this.somethingIsChecked = false;
    });
  }

  async refreshClicked(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }

    this.caHotReloading = true;
    setTimeout(() => (this.caHotReloading = false), 2000);

    const parameter = new Parameter();
    parameter.modifiedBy = this.username;
    parameter.createdBy = this.username;
    parameter.key = 'ca.stack.hotreload';
    parameter.value = 'true';
    parameter.stackId = this.stackId;

    try {
      await this.parameterService.stackHotReload(parameter).toPromise();
      setTimeout(() => {
        this.successAlert = {
          message: `Stack hot Reload for CareAssist has been called.`,
          type: AlertType.SUCCESS,
        };
      }, 1500);
    } catch (e) {
      this.alert = getAlertMessage(e);
    }
  }

}
